import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  url: null,
};

const purchaseOrderSlice = createSlice({
  name: "purchaseOrder",
  initialState,
  reducers: {
    placeOrder(state, action) {
      state.loading = true;
      state.error = null;
    },
    placeOrderSuccess(state, action) {
      state.loading = false;
      state.error = null;
    },
    placeOrderFailure(state, action) {
      state.loading = false;
      state.error = action.payload.message;
    },
    initializeError(state, action) {
      state.error = null;
    },
  },
});

export const { actions, reducer, name: sliceKey } = purchaseOrderSlice;
